import React, { Component } from 'react'
import { postFetchWrapper } from '../../../utils/fetchHelpers'
import buildUrl from '../../../utils/apiHelpers'
import { myListingsIconUrl } from '../../../utils/staticAssets'
import TableCell from '../../Table/TableCell'
import StatusTag from 'components/atoms/ListingsTable/StatusTag'

class UrlTableRow extends Component {
  constructor (props) {
    super(props)

    this.state = {
      cancelledSuccessfully: false
    }

    this.handleCancelLink = this.handleCancelLink.bind(this)
  }

  handleCancelLink () {
    this.setState({ isUpdating: true })
    postFetchWrapper(buildUrl('/api/v1/cancel_url'), { id: this.props.submittedUrl.id })
      .then((response) => response.json())
      .then((data) => {
        console.log('url cancelled', data)
        this.setState({ cancelledSuccessfully: true })
      })
      .catch((error) => {
        console.log('url not cancelled', error)
        this.setState({ cancelledSuccessfully: false })
        // how to handle this in terms of UI?
      })
  }

  render () {
    const { url, submittedAt, rejectionReason } = this.props.submittedUrl
    const status = this.state.cancelledSuccessfully ? 'Cancelled' : this.props.submittedUrl.status
    const formattedSubmittedAt = submittedAt ? new Date(submittedAt).toLocaleDateString() : 'N/A'
    const showCancelCta = status === 'Listing under creation'
    const RejectionReason = status === 'Rejected' && rejectionReason ? rejectionReason : null

    return (
      <tr className='grid p-16 gap-x-16 grid-rows-[minmax(80px,max-content)] border-b border-midnight-black-20 hover:bg-[#FBFCFC]' style={{ gridTemplateColumns: '4fr 1fr', padding: '16px 0px' }}>
        <td>
          <div className='pb-10'> <strong> <span style={{ overflowWrap: 'anywhere', wordBreak: 'break-all' }}> {this.props.index + 1}. {url} </span> </strong> </div>
          <div className='pb-10'> Submitted: {formattedSubmittedAt} </div>
          <StatusTag content={status} />
          {RejectionReason && <div className='col-[4/7] mt-20 py-[5px] px-8 bg-punch-lime-20 rounded min-h-[32px] [@media(max-width:992px)]:mt-10 [@media(max-width:992px)]:w-auto'> {RejectionReason} </div>}
        </td>
        <TableCell
          content={showCancelCta ? <img src={myListingsIconUrl('cross.svg')} /> : ''}
          type={showCancelCta ? 'cancel' : null}
          onCancelLinkClick={this.handleCancelLink}
          style={{ textAlign: 'right' }}
        />
      </tr>
    )
  }
}

export default UrlTableRow
